import React from 'react';

import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
} from '@mui/icons-material';
import {
  Box,
  Collapse,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';

import { Avatar, Badge } from 'src/components/common';

import { LiveStatusSubject } from '../constants';
import { PeoPayrollProviderEmployerValue } from '../types';

import {
  arrowStyles,
  labelStyles,
  logoStyles,
  nameStyles,
  rowEmployerStyles,
  rowStyles,
} from './style';

export type PeoPayrollProviderLiveStatusFormProps = {
  row: {
    subject: string;
    employers?: Array<PeoPayrollProviderEmployerValue>;
  } & PeoPayrollProviderEmployerValue;
  setPeoLiveStatus: (peoId: string) => void;
  setEmployerLiveStatus: (employerId: string) => void;
  setEmployerUnderPeoLiveStatus: (peoId: string, employerId: string) => void;
};

export const PeoPayrollProviderLiveStatusRow: React.FC<PeoPayrollProviderLiveStatusFormProps> = ({
  row,
  setPeoLiveStatus,
  setEmployerLiveStatus,
  setEmployerUnderPeoLiveStatus,
}) => {
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={rowStyles}>
        <TableCell component="th" scope="row">
          <Box sx={labelStyles}>
            <Badge
              invisible={
                !row.isLive || (!row.employers?.length && row.subject === LiveStatusSubject.peo)
              }
              badgeContent="Live"
            >
              <Avatar sx={logoStyles} src={row.logo || ''} variant="circular" />
            </Badge>
            <Typography sx={nameStyles} variant="body2">
              {row.subject === LiveStatusSubject.peo ? `${row.displayName} (PEO)` : row.displayName}
            </Typography>
          </Box>
        </TableCell>
        <TableCell align="right">
          {(!!row.employers?.length || row.subject === LiveStatusSubject.employer) && (
            <Switch
              checked={row.isLive}
              onChange={() =>
                row.subject === LiveStatusSubject.peo
                  ? setPeoLiveStatus(row.id)
                  : setEmployerLiveStatus(row.id)
              }
            />
          )}
        </TableCell>
        <TableCell align="right" sx={arrowStyles}>
          {!!row.employers?.length && (
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table aria-label="purchases">
              <TableBody>
                {row.employers?.map(employer => (
                  <TableRow key={employer.id} sx={rowEmployerStyles}>
                    <TableCell component="th" scope="row">
                      <Box sx={labelStyles}>
                        <Badge invisible={!employer.isLive} badgeContent="Live">
                          <Avatar sx={logoStyles} src={employer.logo || ''} variant="circular" />
                        </Badge>
                        <Typography sx={nameStyles} variant="body2">
                          {employer.displayName}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell align="right">
                      <Switch
                        checked={employer.isLive}
                        onChange={() => setEmployerUnderPeoLiveStatus(row.id, employer.id)}
                      />
                    </TableCell>
                    <TableCell sx={arrowStyles} />
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
